module.exports = __webpack_public_path__ + "img/organization-task.b0a64311.png";